import Common from "../app/Common";
import Helpers from "../inc/Helpers";
import Ajax from "../inc/Ajax";

class Announcements extends Common {
    constructor() {
        super();

        this.helpers = new Helpers();
        this.ajax = new Ajax();

        this.cards = $("body.announcements .cards");
        this.singleSidebarRight = $("body.single-announcement .sidebar-right");
        this.theModal = $("#modal-announcement");
        this.modalAllForms = this.theModal.find("form");
        this.modalProgressBar = this.theModal.find(".progress-bar");
        this.modalAjaxOverlay = this.theModal.find(".ajax-overlay");
        this.modalTriggerButton = $(".new-announcement");
        this.modalCancelButton = this.theModal.find(".btn-cancel");
        this.modalPreviousButton = this.theModal.find(".btn-previous");
        this.modalNextButton = this.theModal.find(".btn-next");
        this.modalProfilesRadios = this.theModal.find('[name="profile"]');
        this.modalIndividualFields = this.theModal.find(".individual-field");
        this.modalIndividualErrors = this.theModal.find(".individual-error");
        this.modalCompanyFields = this.theModal.find(".company-field");
        this.modalCompanyErrors = this.theModal.find(".company-error");
        this.modalChoosenProfileField = this.theModal.find(
            '[name="choosen_profile"]'
        );
        this.modalConfirmation = this.theModal.find(".confirmation");
        this.modalStepsNavigation = this.theModal.find(".steps-nav");
    }

    init() {
        let self = this;

        self.switchTab();
        self.modal();
        self.modalSteps();
        self.modalConditionalProfileForm();
        self.revealClientDetails();
        self.cleanUrl();
        self.directScroll();
        self.mobileNewAnnouncementPopup();
    }

    modal() {
        let self = this;

        self.modalTriggerButton.on("click", function(e) {
            e.preventDefault();
            self.theModal.modal("show");
        });

        self.modalCancelButton.on("click", function(e) {
            e.preventDefault();
            self.theModal.modal("hide");
        });
    }

    modalSteps() {
        let self = this;

        self.theModal.find("input").on("keypress", function(e) {
            if (parseInt(e.keyCode) === 13) {
                self.modalNextButton.trigger("click");
            }
        });

        self.modalPreviousButton.on("click", function(e) {
            e.preventDefault();
            self.modalGoTo("previous");
        });

        self.modalNextButton.on("click", function(e) {
            e.preventDefault();

            let thisBtn = $(this);
            let isPublish = thisBtn.is(".btn-publish");
            let currentForm = self.getModalCurrentForm();
            let modalContent = self.theModal.find(".modal-content");
            let firstError = currentForm.find(".error:not(:hidden)").eq(0);

            let data = currentForm.serializeArray();

            const done = function() {
                if (!isPublish) {
                    self.modalGoTo("next");
                } else {
                    self.modalSubmitAnnouncement();
                }
            };

            const fail = function(response) {
                self.helpers.formErrors(
                    currentForm,
                    response.responseJSON.errors
                );
                self.helpers.scrollToElement(modalContent, firstError, 50);
            };

            const always = function(response, textStatus, xhr) {
                if (isPublish && xhr.status === 200) {
                    return;
                }

                thisBtn.removeClass("disabled");
            };

            currentForm.find(".error").empty();
            thisBtn.addClass("disabled");

            self.ajax.post(
                "/api/modal-announcement/validate-step",
                "JSON",
                data,
                done,
                fail,
                always
            );
        });
    }

    getModalCurrentForm() {
        let self = this;

        return self.theModal.find('form:not(":hidden")');
    }

    getModalTargetForm(direction, currentForm) {
        let self = this;

        let currentStep = self.getModalStep(currentForm);
        let targetStep = self.getModalTargetStep(direction, currentStep);

        return self.theModal.find("form.step-" + targetStep);
    }

    getModalStep(form) {
        return parseInt(form.find('[name="step"]').val());
    }

    getModalTargetStep(direction, currentStep) {
        return direction === "next" ? currentStep + 1 : currentStep - 1;
    }

    modalGoTo(direction) {
        let self = this;

        let currentForm = self.getModalCurrentForm();
        let targetForm = self.getModalTargetForm(direction, currentForm);
        let targetStep = self.getModalStep(targetForm);

        currentForm.hide();
        targetForm.show();

        switch (direction) {
            case "previous":
                if (targetStep === 1) {
                    self.modalCancelButton
                        .show()
                        .css("display", "inline-block");
                    self.modalPreviousButton.hide();
                } else if (targetStep === 3) {
                    self.modalNextButton
                        .removeClass("btn-publish")
                        .html("Suivant >");
                }
                break;

            case "next":
                if (targetStep === 4) {
                    self.modalNextButton
                        .addClass("btn-publish")
                        .html("Publier");
                }

                self.modalCancelButton.hide();
                self.modalPreviousButton.show().css("display", "inline-block");
                break;
        }

        self.modalUpdateProgressBar(targetStep);
    }

    modalConditionalProfileForm() {
        let self = this;

        self.modalProfilesRadios.on("change", function() {
            let thisRadio = $(this);
            let newValue = thisRadio.val();

            if (newValue === "Particulier") {
                self.modalIndividualFields.show();
                self.modalIndividualErrors.show();
                self.modalCompanyFields.hide();
                self.modalCompanyErrors.hide();
                self.modalChoosenProfileField.val("individual");
            } else {
                self.modalIndividualFields.hide();
                self.modalIndividualErrors.hide();
                self.modalCompanyFields.show();
                self.modalCompanyErrors.show();
                self.modalChoosenProfileField.val("company");
            }
        });
    }

    modalUpdateProgressBar(targetStep) {
        let self = this;

        let newPercentage = (targetStep / 4) * 100;

        self.modalProgressBar
            .html(targetStep + "/4")
            .attr("aria-valuenow", newPercentage)
            .css("width", newPercentage + "%");
    }

    modalSubmitAnnouncement() {
        let self = this;

        let data = self.helpers.multipleSerializeArray(self.modalAllForms);

        const done = function() {
            self.modalProgressBar.parent().hide();
            self.modalAllForms.hide();
            self.modalStepsNavigation.hide();
            self.modalConfirmation.show();
        };

        const fail = function() {
            alert(
                "Une erreur a été rencontrée lors de la publication de l'annonce, merci de réessayer ou recharger la page."
            );
        };

        const always = function() {
            self.modalAjaxOverlay.hide();
        };

        self.ajax.post(
            "/api/modal-announcement/send-to-validation",
            "JSON",
            data,
            done,
            fail,
            always
        );
    }

    switchTab() {
        let self = this;

        let triggerButtons = $("body.announcements .col-navigation .btn");

        triggerButtons.on("click", function(e) {
            e.preventDefault();

            let thisButton = $(this);
            let url = thisButton.attr("href");

            const done = function(response) {
                self.cards.html(response);
                self.helpers.scrollToElement("default", self.cards, -75);
            };

            const fail = function() {
                window.location.href = url;
            };

            const always = function() {
                self.cards.css("opacity", 1);
            };

            if (thisButton.is(".selected")) {
                return;
            }

            self.cards.css("opacity", 0.3);

            thisButton.addClass("selected");
            thisButton.siblings().removeClass("selected");

            self.ajax.get(url, "HTML", {}, done, fail, always);
        });
    }

    revealClientDetails() {
        let triggerBtn = $("body.single-announcement .show-infos .btn");

        triggerBtn.on("click", function(e) {
            let thisBtn = $(this);
            let needLogin = thisBtn.hasClass("need-login");

            if (needLogin) {
                return;
            }

            e.preventDefault();

            thisBtn.parent().hide();

            thisBtn
                .closest(".sidebar-right")
                .find("> .block-body")
                .hide();

            thisBtn
                .parent()
                .siblings(".client-infos")
                .show();
        });
    }

    cleanUrl() {
        let self = this;

        if ($("body").is(".single-announcement")) {
            self.helpers.removeURLQueryParam("ds", window.location.href);
        }
    }

    directScroll() {
        let self = this;

        if ($("body").is('[data-direct-show-client-infos="1"]')) {
            self.helpers.scrollToElement(
                "default",
                self.singleSidebarRight,
                -15
            );
        }
    }

    mobileNewAnnouncementPopup() {
        let self = this;

        let popup = $("section.mobile-new-announcement");
        let closeBtn = popup.find(".close-wrapper button");
        let isOnMobile = self.isOnMobile();

        if (!self.cookieConsentWillAppear) {
            popup.fadeIn(150);
        }

        closeBtn.on("click", function() {
            popup.fadeOut(150);

            if (isOnMobile) {
                self.initTawkTo(true);
            }
        });

        $("body").on(
            "click",
            '[aria-label="cookieconsent"] .close_',
            function() {
                popup.fadeIn(150);
            }
        );
    }
}

export default Announcements;
